<div class="mt-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="bg-white shadow rounded p-5">
          <div class="text-center">
            <img src="../../../assets/alt_logo.png" class="w-25 mt-3">
          </div>

          <!-- Email -->
          @if (!isOtpVerified && !isPasswordReset && !showSecurityQuestions) {
            <div>
              <div class="form-group">
                <label class="required">Email Id</label>
                <input type="text" class="form-control" #emailId="ngModel"
                  [(ngModel)]="email" [disabled]="isEmailDisabled" required>
              </div>
              @if (emailId.touched && emailId.invalid) {
                <div class="text-danger">
                  Please enter your email address.
                </div>
              }
              @if (!showOtpFields) {
                <button class="btn btn-primary w-100 mt-4" [disabled]="emailId.invalid || !email"
                (click)="sendOtp()">Send OTP</button>
              }
            </div>
          }

          <!-- Security Questions -->
          @if (showSecurityQuestions && !isSecurityVerified) {
            <div class="mt-3">
              <div class="alert alert-info">
                <strong>Security Verification:</strong> Please answer at least 2 security questions to proceed.
              </div>
              @for (q of securityAnswers; track q; let i = $index) {
                <div class="mb-3">
                  <label class="form-label">{{ securityQuestions[i]?.question }}</label>
                  <input type="text" class="form-control" [(ngModel)]="q.answer"
                    placeholder="Enter your answer" maxlength="100">
                </div>
              }
              <button class="btn btn-primary w-100 mt-3" (click)="verifySecurityAnswers()">
                Verify Answers
              </button>
              <div class="text-center mt-3">
                <button class="btn btn-link" (click)="showSecurityQuestions = false; email = ''; isEmailDisabled = false;">
                  Change Email
                </button>
              </div>
            </div>
          }

          <!-- OTP -->
          @if (showOtpFields && !isOtpVerified) {
            <div class="mt-3">
              <div class="form-group">
                <label>Enter OTP</label>
                <input type="number" class="form-control" [(ngModel)]="otp" maxlength="4" required>
              </div>
              @if (!canResend) {
                <button class="btn btn-primary w-100 mt-3" (click)="verifyOtp()">Verify
                OTP</button>
              }
              <div class="text-center mt-3">
                @if (!canResend) {
                  <span>
                    Didn't get an OTP? <span class="text-muted">Resend in {{resendTimer}}s</span>
                  </span>
                }
                @if (canResend) {
                  <a class="btn btn-link p-0" (click)="resendOtp()">Resend OTP</a>
                }
              </div>
            </div>
          }

          <!-- New Password -->
          @if (isOtpVerified && !isPasswordReset) {
            <div class="mt-2">
              <div class="form-group mt-3">
                <label class="form-label required" for="newPassword">New Password</label>
                <div class="input-group">
                  <input [type]="newPasswordType" class="form-control" id="newPassword"
                    [(ngModel)]="newPassword" name="newPassword" required />
                  <span class="input-group-text pointer" (click)="onShowPassword('new')">
                    <i class="bi" [ngClass]="showNewPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                  </span>
                </div>
                @if (newPassword) {
                  <div class="mt-2">
                    <small class="d-block" [class.text-success]="newPassword.length >= 12" [class.text-muted]="newPassword.length < 12">
                      <i class="bi" [class.bi-check]="newPassword.length >= 12" [class.bi-x]="newPassword.length < 12"></i> At least 12 characters
                    </small>
                    <small class="d-block" [class.text-success]="hasUpperCase(newPassword)" [class.text-muted]="!hasUpperCase(newPassword)">
                      <i class="bi" [class.bi-check]="hasUpperCase(newPassword)" [class.bi-x]="!hasUpperCase(newPassword)"></i> 1 uppercase letter
                    </small>
                    <small class="d-block" [class.text-success]="hasLowerCase(newPassword)" [class.text-muted]="!hasLowerCase(newPassword)">
                      <i class="bi" [class.bi-check]="hasLowerCase(newPassword)" [class.bi-x]="!hasLowerCase(newPassword)"></i> 1 lowercase letter
                    </small>
                    <small class="d-block" [class.text-success]="hasNumber(newPassword)" [class.text-muted]="!hasNumber(newPassword)">
                      <i class="bi" [class.bi-check]="hasNumber(newPassword)" [class.bi-x]="!hasNumber(newPassword)"></i> 1 number
                    </small>
                    <small class="d-block" [class.text-success]="hasSpecialChar(newPassword)" [class.text-muted]="!hasSpecialChar(newPassword)">
                      <i class="bi" [class.bi-check]="hasSpecialChar(newPassword)" [class.bi-x]="!hasSpecialChar(newPassword)"></i> 1 special character
                    </small>
                  </div>
                }
              </div>
              <div class="form-group mt-3">
                <label class="form-label required" for="confirmPassword">Confirm Password</label>
                <div class="input-group">
                  <input [type]="confirmPasswordType" class="form-control" id="confirmPassword"
                    [(ngModel)]="confirmPassword" name="confirmPassword" required />
                  <span class="input-group-text pointer" (click)="onShowPassword('confirm')">
                    <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                  </span>
                </div>
                @if (confirmPassword && newPassword !== confirmPassword) {
                  <div class="text-danger mt-1">
                    Passwords do not match
                  </div>
                }
              </div>
              <button class="btn btn-warning w-100 mt-4"
                [disabled]="!newPassword || !confirmPassword || newPassword !== confirmPassword || !isPasswordValid(newPassword)"
              (click)="resetPassword()">Reset Password</button>
            </div>
          }

          <!-- Success -->
          @if (isPasswordReset) {
            <div class="text-center mt-4">
              <p class="text-success fw-bold">Password reset successfully!</p>
              <a routerLink="/" class="btn btn-link">Back to Login</a>
            </div>
          }

          <!-- Error -->
          @if (errorMessage) {
            <div class="mt-3">
              <ngb-alert type="danger" (closed)="errorMessage = '' ">{{ errorMessage }}</ngb-alert>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
